// Constants
import { CUSTOMER_FORM_EXTERNAL_ACCESS_PATH } from '@/constants/external-access-constants';

export function isCustomerFormExternalAccessPath(path) {
  return String(path || '').includes(CUSTOMER_FORM_EXTERNAL_ACCESS_PATH);
}

export function isOnCustomerFormExternalAccess() {
  return isCustomerFormExternalAccessPath(window.location.pathname);
}
